import { Textarea as ChakraTextarea } from '@chakra-ui/react';
import { FormControlOptions, PolymorphicProps, StyleProps, SystemProps, ThemingProps } from './primitives.types';

export interface TextareaProps extends
  SystemProps,
  PolymorphicProps,
  FormControlOptions,
  ThemingProps,
  Omit<React.ComponentPropsWithoutRef<'textarea'>, keyof StyleProps | keyof FormControlOptions | keyof ThemingProps> {
  focusBorderColor?: string;
  errorBorderColor?: string;
  resize?: 'none' | 'both' | 'horizontal' | 'vertical';
}

export function Textarea(props: TextareaProps) {
  return <ChakraTextarea {...props} />;
}